/* eslint-disable prettier/prettier */
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 24px;
  box-sizing: border-box;
  gap: 12px;
  font-family: Inter;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #646363;
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;

  p {
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: left;
    color: #424248;
  }

  div {
    display: flex;
    width: 100%;
    height: 44px;
    align-items: center;
    padding: 2px 8px 2px 8px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    gap: 8px;

    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      font-size: 16px;
      font-weight: 400;
      color: #374151;

      &::placeholder {
        color: #0000004d;
      }
    }
  }
`;

export const ColorPickerContainer = styled.div`
  width: 100%;

  .react-colorful {
    border-radius: 4px;
  }

  .react-colorful__saturation {
    margin: 0 0 8px 0;
    border-radius: 5px;
    border-bottom: none;
  }

  .react-colorful__saturation-pointer {
    width: 20px;
    height: 20px;
  }

  .react-colorful__alpha {
    margin: 8px 0 0 0;
  }

  .react-colorful__hue,
  .react-colorful__alpha {
    height: 14px;
    border-radius: 100px;
  }

  .react-colorful__hue-pointer,
  .react-colorful__alpha-pointer {
    width: 20px;
    height: 20px;
  }
`;

export const ColorPickerDetails = styled.div`
  display: grid;
  grid-template-columns: 2fr 8fr;
  align-items: center;
  grid-gap: 12px;
  width: 100%;
`;

export const HexOrRgba = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  align-items: center;
  padding: 2px 4px 2px 6px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    color: #374151;
  }

  .icons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;

export const HexInput = styled.div`
  display: flex;
  width: 100%;
  height: 28px;
  align-items: center;
  padding: 2px 6px 2px 6px;
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  gap: 8px;

  p {
    font-size: 16px;
    font-weight: 200;
    color: #9ca3af;
  }

  input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    font-weight: 400;
    color: #374151;
  }
`;

export const RgbaInput = styled.div`
  display: flex;
  width: 100%;
  height: 28px;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    width: 100%;
    height: 28px;
    align-items: center;
    gap: 4px;

    .label {
      font-size: 14px;
      font-weight: 400;
      color: #374151;
    }

    div {
      display: flex;
      width: 100%;
      height: 28px;
      align-items: center;
      gap: 4px;
      padding: 2px 6px 2px 6px;
      border-radius: 4px;
      border: 1px solid #e5e7eb;

      input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 400;
        color: #374151;
      }
    }
  }
`;

export const ColorsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  p {
    font-size: 12px;
    color: #374151;
    font-weight: 500;
  }
`;

export const AddColor = styled.div<{ disabled?: boolean }>`
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${({ disabled }) => (disabled ? "#e5e7eb" : "#2d5bff ")};

  :hover {
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  }

  p {
    font-size: 12px;
    color: ${({ disabled }) => (disabled ? "#9ca3af" : "#ffffff")};
    font-weight: 500;
  }
`;

export const Colors = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  align-items: center;
  width: 100%;
  grid-gap: 8px;
`;

export const Color = styled.div<{ color: string; selected?: boolean }>`
  width: 24px;
  height: 24px;
  background: ${({ color }) => color};
  border-radius: 50%;
  cursor: pointer;

  ${({ selected }) =>
    selected &&
    "border: 8px solid transparent; outline: 2px solid #bfbfbf; outline-offset: 2px;"};
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;

  h1 {
    font-size: 14px;
    font-weight: 500;
    color: #424248;
    line-height: 21px;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
`;

export const Tag = styled.div<{ color: string; selected?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  gap: 2px;

  p {
    display: flex;
    align-items: center;
    gap: 4px;
    max-height: 26px;
    font-size: 14px;
    font-weight: 500;
    padding: 4px 8px;
    color: white;
    background-color: ${({ color }) => color};
    border-radius: 8px;

    ${({ selected }) =>
    selected &&
    "border: 2px solid transparent; outline: 2px solid #bfbfbf; outline-offset: 2px;"};
  }

  .icons {
    cursor: pointer;
    color: white;
  }
`;

export const Buttons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  width: 100%;

  button {
    padding: 8px;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    height: 40px;
  }

  .primary {
    background-color: #2d5bff;
    color: white;
  }

  .secondary {
    background-color: transparent;
    color: #424248;
    outline: 1px solid #a3a3a6;
  }

  .disabled {
    opacity: 0.6 !important;
    cursor: not-allowed !important;
  }
`;

export const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 24px;
  box-sizing: border-box;
  font-family: Inter;
  gap: 20px;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    color: #646363;
  }
`;
